import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import SidebarContext from '../../../contexts/sidebar';
import './index.css';

const Submenu = (props) => {
    const [subnav, setSubnav] = useState(false);
    const sidebarContext = useContext(SidebarContext);

    const handleMenuOption = () => {
        if (props.item.subNav) setSubnav(!subnav);

        if (sidebarContext.isMobile && sidebarContext.sidebarOpen && !props.item.subNav) sidebarContext.closeSidebar();
            
        sidebarContext.handleChangeCurrentPage(props.item.title);
    }

    const handleSubmenuOption = () => {
        if (!sidebarContext.sidebarOpen) setSubnav(!subnav);

        if (sidebarContext.isMobile && sidebarContext.sidebarOpen)
        {
            setSubnav(!subnav);
            sidebarContext.closeSidebar();
        }
    }

    useEffect(() => {
        if (sidebarContext.sidebarOpen === false) setSubnav(false);
    }, [sidebarContext.sidebarOpen]);

    return(
        <>
            { !props.item.subNav ?
                <Link className={ "sidebarLink" + (props.item.title === sidebarContext.currentPage ? " current-page" : "") } to={props.item.path} onClick={ () => handleMenuOption() }>
                    <div>
                        {props.item.icon}
                        <span className={ "text-bold sidebarLabel" + (sidebarContext.sidebarOpen ? "" : "-close") }>{props.item.title}</span>
                    </div>
                    <div>
                        {props.item.subNav && subnav ? 
                            props.item.iconOpened 
                            :
                            props.item.subNav ? props.item.iconClosed : null}
                    </div>
                </Link>
                :
                <div className={ "sidebarLink" + (props.item.title === sidebarContext.currentPage ? " current-page" : "") } onClick={ () => handleMenuOption() }>
                    <div>
                        {props.item.icon}
                        <span className={ "text-bold sidebarLabel" + (sidebarContext.sidebarOpen ? "" : "-close") }>{props.item.title}</span>
                    </div>
                    <div>
                        {props.item.subNav && 
                            subnav ? 
                                props.item.iconOpened
                                :
                                props.item.subNav ? props.item.iconClosed : null
                        }
                    </div>
                </div>
            }            

            <ul className={ sidebarContext.sidebarOpen ? "d-flex flex-column" : "submenu-ul"}>
            {
                subnav && 
                    (props.item.title === sidebarContext.currentPage ? props.item.subNav.map((item, index) => {
                        return <li key={index}>
                                    <Link className="dropdownLink" to={item.path} onClick={ () => handleSubmenuOption() } >
                                        <span className="sidebarLabel" >{item.title}</span>
                                    </Link>
                                </li>
                    }) 
                    : 
                    setSubnav(false)
                )
            }
            </ul>
        </>
    );
}

export default Submenu;